import React, { useEffect, useState } from "react";
import { getImageAsBase64 } from '../../helpers/fetchDatafromContentSVC';
/**
 *
 * @param {object} props
 * @returns
 */
export default function SolutionImagesMD(props) {
  const {src,alt,url,solType} = props; 
  const [mounted, setMounted] = useState();
  const [imgData, setimgData] = useState('');
  const resPath = `${url}?resourcePath=/solutions/${solType}&resourceName=${src}`
  let srcReplace = resPath.replace("&resourceName=/resources/", "/resources&resourceName=")
  const imgdata = getImageAsBase64(srcReplace);
  imgdata.then(result => {
    setimgData(result)
  })
  useEffect(() => {
   
    setMounted(true);
  }, [imgdata]);
  if (!mounted) {
    return <></>;
  }
  return (
    <img className="solutions_solutionDetails_apisImg_wrapper py-4" src={`data:image/jpeg;charset=utf-8;base64,${imgData}`} alt={alt} />
  )
  
}
